import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching dashboard data
export const fetchDashboard = createAsyncThunk(
    'dashboard/fetchDashboard',
    async (_, thunkAPI) => {
        try {
            console.log('...fetching Dashboard data....');
            const response = await fetch(`${process.env.REACT_APP_BASE_URL ?? "https://backend.carbez.com"}/api/dashboard`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            });
            
            if (!response.ok) {
                throw new Error('Failed to fetch dashboard data');
            }
            
            const data = await response.json();
            console.log('Dashboard data fetched:', data);
            return data;
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const initialState = {
    dashboardData: {
        carCount: 0,
        cars: [],
        enlistCarCount: 0,
        enlistCar: [],
        userCount: 0,
        users: []
    },
    status: 'idle',
    error: null,
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        resetDashboard(state) {
            state.dashboardData = initialState.dashboardData;
            state.status = 'idle';
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboard.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchDashboard.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.dashboardData = action.payload;
                state.error = null;
            })
            .addCase(fetchDashboard.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Failed to fetch dashboard data';
            });
    },
});

export const { resetDashboard } = dashboardSlice.actions;

export default dashboardSlice.reducer;